import { EventEmitter, Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable, catchError } from 'rxjs';
import { FilterModel } from '../shared/components/local-filter/filter-model';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class InfoReportService extends ServiceBase {
  infoReportUpdated$ = new EventEmitter<ServerModels.ENESS_IntelligenceReports>();
  readonly hasInfoReportStorageKey: string = 'hasAssignedInfoReport';

  public addOrUpdateInformationReport(infoReport: ServerModels.ENESS_IntelligenceReports) {
    return this.http.post(`${this.apiRoot}/api/IntelligenceReport/AddOrUpdateIntelligenceReport`, infoReport, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('addOrUpdateInformationReport', 'defaultMsg', null, null))); 
  }

  public deleteInformationReportAttachment(file: ServerModels.ENESS_IntelligenceReportAttachments): Observable<number> {
    return this.http.post<number>(`${this.apiRoot}/api/IntelligenceReport/DeleteIntelligenceReportAttachment`, file, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('deleteIntelligeneReportAttachment', 'defaultMsg', null, null))); 
 }

  public getCGICPersonnelIncludeAgency(cgicCode: string): Observable<ServerModels.CGICPersonnelViewModel[]> {
    let options = {
      headers: this.httpOptions.headers,
      params: { 'cgicCode': cgicCode }
    };

    return this.http.get<ServerModels.CGICPersonnelViewModel[]>(`${this.apiRoot}/api/IntelligenceReport/GetCGICPersonnelIncludeAgency`, options)
      .pipe(catchError(this.swallowError<any>('getCGICPersonnelIncludeAgency', 'defaultMsg', null, null))); 
  }

  public getCrimeGunIds(query: string): Observable<ServerModels.CrimeGunSelectionValues[]> {
    let options = {
      headers: this.httpOptions.headers,
      params: { 'query': query }
    };
    return this.http.get<ServerModels.CrimeGunSelectionValues[]>(`${this.apiRoot}/api/IntelligenceReport/GetCrimeGunIds`, options)
      .pipe(catchError(this.swallowError<any>('getCrimeGunIds', 'irCrimeGuns', null, null))); 
 }

  public getInformationReportPriorites(): Observable<ServerModels.ENESS_REF_IntelligenceReportPriorities[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportPriorities[]>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportPriorites`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getInformationReportPriorities', 'defaultMsg', null, null))); 
  }

  public getInformationReportPurposes(): Observable<ServerModels.ENESS_REF_IntelligenceReportPurposes[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportPurposes[]>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportPurposes`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getInformationReportPurposes', 'defaultMsg', null, null))); 
  }

  public getInformationReportStatuses(): Observable<ServerModels.ENESS_REF_IntelligenceReportStatuses[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportStatuses[]>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportStatuses`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getInformationReportStatuses', 'defaultMsg', null, null))); 
  }

  public getInformationReportTypes(): Observable<ServerModels.ENESS_REF_IntelligenceReportTypes[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportTypes[]>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportTypes`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getInformationReportTypes', 'defaultMsg', null, null))); 
  }


  public getAttachmentById(infoReportId: string, attachmentId: string): Observable<Blob> {
    let options = {
      responseType: 'blob' as 'json',
      params: {
        'intelligenceReportId': infoReportId,
        'attachmentId': attachmentId
      }
    };
    return this.http.get<Blob>(`${this.apiRoot}/api/IntelligenceReport/GetAttachmentById`, options)
      .pipe(catchError(this.throwError<any>('getAttachmentById', 'defaultMsg', null, null)));
  }

  public getATFReferralGroups(): Observable<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups[]>(`${this.apiRoot}/api/IntelligenceReport/GetATFReferralGroups`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getATFReferralGroups', 'defaultMsg', null, null))); 
  }

  public getFieldDivisions(): Observable<ServerModels.ENESS_REF_FieldDivisions[]> {
    return this.http.get<ServerModels.ENESS_REF_FieldDivisions[]>(`${this.apiRoot}/api/IntelligenceReport/GetFieldDivisions`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getFieldDivisions', 'defaultMsg', null, null))); 
  }

  public getInformationReportById(infoReportId: string): Observable<ServerModels.ENESS_IntelligenceReports> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'intelligenceReportID': infoReportId }
    };
    return this.http.get<ServerModels.ENESS_IntelligenceReports>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportByID`, options)
      .pipe(catchError(this.swallowError<any>('getInformationReportById', 'defaultMsg', null, null))); 
  }

  public getIRLECaseNumbersByIRID(infoReportId: string): Observable<ServerModels.IRLECaseNumbersViewModel[]> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'intelligenceReportID': infoReportId }
    };
    return this.http.get<ServerModels.IRLECaseNumbersViewModel[]>(`${this.apiRoot}/api/IntelligenceReport/GetIRLECaseNumbersByIRID`, options)
      .pipe(catchError(this.swallowError<any>('getIRLECaseNumbersByIRID', 'defaultMsg', null, null))); 
  }

  public getIRLECaseNumbersByLECaseNumberIDs(LECaseNumberId: string): Observable<ServerModels.IRLECaseNumbersViewModel> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'leCaseNumberId': LECaseNumberId }
    };
    return this.http.get<ServerModels.IRLECaseNumbersViewModel>(`${this.apiRoot}/api/IntelligenceReport/GetIRLECaseNumbersByLECaseNumberID`, options)
      .pipe(catchError(this.swallowError<any>('getIRLECaseNumbersByLECaseNumberIDs', 'defaultMsg', null, null)));
  }

  public getCrimeGunViewModelByIRID(infoReportId: string): Observable<ServerModels.IRCrimeGunViewModel[]> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'intelligenceReportID': infoReportId }
    };
    return this.http.get<ServerModels.IRCrimeGunViewModel[]>(`${this.apiRoot}/api/IntelligenceReport/GetCrimeGunViewModelByIRID`, options)
      .pipe(catchError(this.swallowError<any>('getCrimeGunViewModelByIRID', 'defaultMsg', null, null)));
  }

  public getCrimeGunViewModelByCrimeGunID(LECaseNumberId: string): Observable<ServerModels.IRCrimeGunViewModel> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'leCaseNumberId': LECaseNumberId }
    };
    return this.http.get<ServerModels.IRCrimeGunViewModel>(`${this.apiRoot}/api/IntelligenceReport/GetCrimeGunViewModelByCrimeGunID`, options)
      .pipe(catchError(this.swallowError<any>('getCrimeGunViewModelByCrimeGunID', 'defaultMsg', null, null)));
  }

  public getInformationReportView(pageNumber: number, filters: FilterModel): Observable<ServerModels.IntelligenceReportViewModel[]> {
    let userUTCOffsetMins = moment().utcOffset();
    let options = {
      headers: this.httpNoCache.headers,
      params: {
        'pageNumber': pageNumber.toString(),
        'startDate': moment(filters.startDate).format('MM/DD/YYYY'),
        'endDate': moment(filters.endDate).format('MM/DD/YYYY'),
        'selectedCGICCode': filters.cgicCode,
        'userUTCOffset': userUTCOffsetMins.toString()
      }
    };
    return this.http.get<ServerModels.IntelligenceReportViewModel[]>(`${this.apiRoot}/api/IntelligenceReport/GetIntelligenceReportView`, options)
      .pipe(catchError(this.throwError<any>('getInformationReportView', 'irsMsg', null, null)));
  }

  public getUserIsAssignedToIR(): Observable<boolean> {
    let headersObj = this.httpNoCache.headers.append('Skip-Loader', 'true');
    let options = {
      headers: headersObj
    };

    return this.http.get<boolean>(`${this.apiRoot}/api/IntelligenceReport/UserIsAssignedToIR`, options)
      .pipe(catchError(this.throwError<any>('getUserIsAssignedToIR', 'defaultMsg', null, null)));
  }

  public updateInfoReportEvent(ir: ServerModels.ENESS_IntelligenceReports) {
    if (ir) {
      this.infoReportUpdated$.emit(ir);
    }
  }
}
